import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { initAppAction } from 'src/store/view/actions';

export interface IPartnerLoyaltyInfo {
  title: string;
  description: string;
  logo: string;
  color: string;
}

export interface PartnerLoyaltyState {
  partnerLoyaltyInfo: IPartnerLoyaltyInfo | null;
  partnerLoyaltyProgramCardNumber: string | null;
}

const initialState = {
  partnerLoyaltyInfo: null,
  partnerLoyaltyProgramCardNumber: null,
} as PartnerLoyaltyState;

const PartnerLoyaltySlice = createSlice({
  name: 'partnerLoyalty',
  initialState,
  reducers: {
    setPartnerLoyaltyProgramCardNumber(
      state,
      action: PayloadAction<
        PartnerLoyaltyState['partnerLoyaltyProgramCardNumber']
      >,
    ) {
      state.partnerLoyaltyProgramCardNumber = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initAppAction, (state, { payload: { ...rest } }) => {
      const { partner_loyalty } = rest as Record<string, IPartnerLoyaltyInfo>;

      return {
        ...state,
        partnerLoyaltyInfo: partner_loyalty,
      };
    });
  },
});

export const { setPartnerLoyaltyProgramCardNumber } =
  PartnerLoyaltySlice.actions;

export const { name } = PartnerLoyaltySlice;
export default PartnerLoyaltySlice.reducer;
